import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subcuentas-panel',
  templateUrl: './subcuentas-panel.component.html',
  styleUrls: ['./subcuentas-panel.component.scss']
})
export class SubcuentasPanelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
